module.exports = __webpack_public_path__ + "img/banner.56bc7d41.png";